import { useEffect, /*useMemo,*/ useState } from "react";
//import { useIntl } from "react-intl";
//import { useMedia } from "react-use";
import styled from "styled-components";
import { useCamera, useMode, useZLBolt } from "@zerolight-core/libzl-react"
import { /*Instructions, InstructionsOrbitMouse, InstructionsOrbitTouch*/ } from "slate-ui-components";

const Container = styled.div<{$idle: boolean}>`
	opacity: ${({$idle}) => $idle ? 1 : 0};
	pointer-events: ${({$idle}) => $idle ? "auto" : "none"};
`

export const IdleOverlay = () => {
//	const intl = useIntl();
	const zlbolt = useZLBolt();
	const camera = useCamera();
	const mode = useMode();
	const [idle, setIdle] = useState(false)
	const [cameraMoved, setCameraMoved] = useState(false)
//	const [shown, setShown] = useState(0)
//	const touch = useMedia("(pointer: course)")

	const canMoveCamera = mode === "3D" || camera === zlbolt?.movableExteriorCamera || camera === zlbolt?.movableInteriorCamera;

	useEffect(() => {
		if(zlbolt) {
			const onIdle = () => {
				setIdle(true);
			}
			const onActive = () => {
				setIdle(false);
			}
			const onCameraMove = () => {
				setCameraMoved(true)
			}
			zlbolt.addEventListener("streamBecameIdle", onIdle)
			zlbolt.addEventListener("streamBecameActive", onActive)
			zlbolt.addEventListener("cameraMoving", onCameraMove)
			return () => {
				zlbolt.removeEventListener("streamBecameIdle", onIdle)
				zlbolt.removeEventListener("streamBecameActive", onActive)
				zlbolt.removeEventListener("cameraMoving", onCameraMove)
			}

		}
	}, [zlbolt])

/*
	useEffect(() => {
		if(idle && camera === zlbolt.movableExteriorCamera) {
			setShown(prevCount => prevCount + 1)
		}
	}, [idle, camera, zlbolt])
*/
/*
	const {icon, message} = useMemo(() => {
		if(touch) {
			return {
				icon: null,//<InstructionsOrbitTouch/>,
				message: intl.formatMessage({id: "instructions.rotate_touch", defaultMessage: "Drag to rotate"})
			}
		}
		return {
			icon: null, //<InstructionsOrbitMouse/>,
			message: intl.formatMessage({id: "instructions.rotate_mouse", defaultMessage: "Click and drag to rotate"})
		}
	}, [intl, touch])
*/
	if(!zlbolt || !canMoveCamera || cameraMoved) {
		return null
	}

	return (
		<Container $idle={idle}>
			{/*<Instructions message={message} icon={icon} />*/}
		</Container>
	)
}